import type { ExplorationAccountCache } from '../types/exploration';

/** Tags each child account cache with its org parent id for account-option grouping. */
export function stampOrgChildParentIds(
  caches: Record<string, ExplorationAccountCache>,
  childIds: string[],
  parentAccountId: string
): void {
  childIds.forEach((childId) => {
    if (caches[childId]) {
      caches[childId] = { ...caches[childId], _orgParentId: parentAccountId };
    }
  });
}
